import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import button from './viewAllButton.module.css';
import { Link } from 'react-router';

export default function ViewAllButton(props) {
    return (
        <> <Link to={props.path}  >
            <button className={button.btn}>
                {props.name} <span><ArrowRightAltIcon /></span>
            </button>
        </Link>
        </>
    )
}